import { ReactNode } from 'react'


export const PageTitle = ({children}: {children: ReactNode}) => {
  return (
    <h1 className='page-title py-3 ps-4'>{children}</h1>
  )
}
